import { render, staticRenderFns } from "./ParametricRootChildren.vue?vue&type=template&id=823ed936&scoped=true&"
import script from "./ParametricRootChildren.vue?vue&type=script&lang=js&"
export * from "./ParametricRootChildren.vue?vue&type=script&lang=js&"
import style0 from "./ParametricRootChildren.vue?vue&type=style&index=0&id=823ed936&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823ed936",
  null
  
)

export default component.exports